import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownDTO } from "../../../types/common/DropdownDTO";

interface IIncotermState {
  incotermDropdown: DropdownDTO[];
}

const initialState: IIncotermState = {
  incotermDropdown: [],
};

export const incotermSlice = createSlice({
  name: "incoterm",
  initialState,
  reducers: {
    loadingIncotermDropdown: (state, action: PayloadAction<DropdownDTO[]>) => {
      state.incotermDropdown = action.payload;
    },
  },
});

export const { loadingIncotermDropdown } = incotermSlice.actions;

export default incotermSlice.reducer;
